const profile = {
    name: 'İsim',
    avatar: 'Avatar',
    givenName: 'Ad',
    familyName: 'Soyad',
    middleName: 'İkinci Ad',
    fullname: 'Tam Ad',
    nickname: 'Takma Ad',
    preferredUsername: 'Tercih Edilen Kullanıcı Adı',
    profile: 'Profil',
    website: 'Web Sitesi',
    gender: 'Cinsiyet',
    birthdate: 'Doğum Tarihi',
    zoneinfo: 'Zaman Dilimi',
    locale: 'Dil',
    address: {
        formatted: 'Adres',
        streetAddress: 'Sokak adresi',
        locality: 'Şehir',
        region: 'Eyalet/İl',
        postalCode: 'Posta kodu',
        country: 'Ülke',
    },
    gender_options: {
        female: 'Kadın',
        male: 'Erkek',
        prefer_not_to_say: 'Söylememeyi tercih ederim',
    },
};
export default Object.freeze(profile);
